export default "__VITE_ASSET__BPS3d9kC__"